export default ({status, vendor }) => {
  return [
    {
      label: 'Гарчиг',
      name: 'title',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Нийлүүлэгч',
      name: 'vendorid',
      className: 'col-span-12 mb-0',
      type: 'select',
      inputProps: {
        options: vendor
      }
    },
    {
      label: 'Дүн',
      name: 'totalamount',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Агуулах/Дэлгүүр',
      name: 'warehouseid',
      type: 'select',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Тоо ширхэг',
      name: 'qty',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Тайлбар',
      name: 'description',
      className: 'col-span-6 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Төлөв',
      name: 'status',
      type: 'select',
      className: 'col-span-6 mb-0',
      inputProps: {
        options: status
      }
    },
  ]
}